import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { mapState } from 'vuex';
export default {
  name: 'tagView',
  data() {
    return {
      tagBodyLeft: 0,
      hanldeBtn: false
    };
  },
  computed: {
    ...mapState({
      tagList: state => state.tagsView.tagList
    }),
    outerWidth() {
      if (this.hanldeBtn) {
        return {
          left: '30px',
          right: '34px'
        };
      }
      return {
        left: '15px',
        right: '15px'
      };
    }
  },
  mounted() {
    this.addTag();
    this.changeTagWidth();
  },
  methods: {
    isActive(path) {
      return path == this.$route.name;
    },
    addTag() {
      const {
        path,
        meta,
        name
      } = this.$route;
      let num = -1;
      this.tagList.map((item, index) => {
        if (item.name == name) {
          num = index;
        }
      });
      if (name != 'toPay' && this.tagList.findIndex(i => i.name == 'toPay') > -1) {
        var _this$tagList$find;
        this.closeTag((_this$tagList$find = this.tagList.find(i => i.name == 'toPay')) === null || _this$tagList$find === void 0 ? void 0 : _this$tagList$find.path, this.tagList.findIndex(i => i.name == 'toPay'));
      }
      if (num == -1) {
        this.$store.dispatch('tagsView/addTag', {
          path,
          meta,
          name
        });
      } else {
        this.tagList[num] = {
          path,
          meta,
          name
        };
      }
    },
    closeTag(path, index) {
      console.log(path, index);
      // if (path == '/invoiceManage/homeManage/invoiceRecord') {
      //   sessionStorage.removeItem('invoiceRecordApplicationId');
      //   sessionStorage.removeItem('invoiceRecordInsuranceId');
      // }
      this.$store.dispatch('tagsView/removeTag', path).then(data => {
        // console.log(path, this.$route.path, 'this.isActive(path)');
        if (path === this.$route.path) {
          console.log(index);
          this.$router.push({
            path: data[index - 1].path
          });
        }
        this.changeTagWidth();
        this.moveToTag();
      });
    },
    handleScroll(val) {
      const scrollOuterWidth = this.$refs.scrollOuter.offsetWidth;
      const scrollBodyWidth = this.$refs.scrollBody.offsetWidth;
      if (val > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + val);
      } else {
        this.tagBodyLeft = Math.max(this.tagBodyLeft + val, scrollOuterWidth - scrollBodyWidth);
      }
    },
    changeTagWidth() {
      const scrollOuterWidth = this.$refs.scrollOuter.offsetWidth;
      const scrollBodyWidth = this.$refs.scrollBody.offsetWidth;
      if (scrollBodyWidth >= scrollOuterWidth - 50) {
        this.hanldeBtn = true;
      } else {
        this.hanldeBtn = false;
      }
    },
    moveToTag() {
      this.$nextTick(() => {
        const index = this.tagList.findIndex(item => item.path == this.$route.path);
        const eleWidth = this.$refs.tagWrapper[index].$el.offsetWidth;
        const eleLeft = this.$refs.tagWrapper[index].$el.offsetLeft;
        const scrollOuterWidth = this.$refs.scrollOuter.offsetWidth;

        //标签在左边
        if (eleLeft == 0 && index == 0) {
          return;
        }
        if (eleLeft < -this.tagBodyLeft) {
          this.tagBodyLeft = -eleLeft + 4;
        } else if (eleLeft > -this.tagBodyLeft && eleLeft + eleWidth < -this.tagBodyLeft + scrollOuterWidth) {
          this.tagBodyLeft = Math.min(0, scrollOuterWidth - eleWidth - eleLeft - 4);
        } else {
          this.tagBodyLeft = -(eleLeft - (scrollOuterWidth - 4 - eleWidth));
        }
      });
    }
  },
  watch: {
    $route(nl) {
      this.changeTagWidth();
      this.addTag();
      this.moveToTag();
    }
  }
};